import { coreManifest } from '@confluent/shared/modules';
import type { ClientModule } from '../registry.js';
import { corePanelTypes } from './entity-panels.js';
import { coreRoutes } from './routes.js';

export const coreClientModule: ClientModule = {
  manifest: coreManifest,
  routes: coreRoutes,
  panelTypes: corePanelTypes,
};
